import React, { useState, useEffect, useRef } from 'react';
import { Card, MultiStepTracker, Step } from '@americanexpress/dls-react';
import { useLocation, useParams, useHistory } from "react-router-dom";
import { SideBar, Banner, Loading } from '../../components';
import { StageOne, StageTwoForm, StageThree } from '../TwoStageForm'
import { UserProvider } from '../../components/ContextComponent/UserContext';
import { GO2Declined, LmsDeclined, GO2Approved, GO2Pended } from '../JourneyCompletion';
import { API_ENDPOINTS, CONSTANTS } from '../../constants';
import { GenericError, GenericErrorForStage2, Error422, Error422ForStage2 } from '../Error';
import InitializeBiocatchInauth from '../../services/BiocatchInauthTracking';
import { LimitExceed } from '../LimitExceed';
import { MetaPixel } from '../../utils/MetaPixel';
import {
    AmazonPixelBaseCode,
    AmazonPixelAboutYouSubmitted,
    AmazonPixelAdditionalInfoClicked
} from '../../utils/AmazonPixel';
import { JioPixel } from '../../utils/JioPixel';
import { IMOPixel, CallIMOOnAgreeAndContinue } from '../../utils/IMOPixel';
import { CriteoPixel, CallCriteoOnAgreeAndContinue } from '../../utils/CriteoPixel';
import { TaboolaPixel } from '../../utils/TaboolaPixel';
import { ThinkResultPixel } from '../../utils/ThinkResultPixel';
import { LinkedInPixel } from '../../utils/LinkedInPixel';

function TwoStageForm() {
    const [stage, setStage] = useState(0);
    const [data, setTwoStageFormData] = useState(null);
    const [loading, setLoading] = useState(false);

    let { product, page, offerCode, Siteid, AdUnit, BannerName, MarketingAgency, SpecialCampaign, Campaign,
        Keyword, Adgroup, CPID, Partner} = useParams();
    const errorMessage = "Sorry, we encountered some issue while processing your request. Kindly try again.";
    const location = useLocation();
    
    const [formData, setFormData] = useState({
        prospectID: 0,
        title: '',
        firstName: '',
        middleName: '',
        lastName: '',
        dateOfBirth: '',
        panNumber: '',
        haveForm60: false,
        email: '',
        mobileNumber: '',
        homeAddressLine1: '',
        homeAddressLine2: '',
        homeAddressLine3: '',
        homeCity: '',
        homeState: '',
        homePin: '',
        employmentStatus: '',
        annualIncome: '',
        disclaimer: false,
        //Stage Two
        schoolID: 0,
        schoolEmail: '',
        companyName: '',
        companyEmail: '',
        industry: '',
        OfficeAddressLine1: '',
        OfficeAddressLine2: '',
        OfficeAddressLine3: '',
        CompanyAddressPincode: '',
        companyAddressCity: '',
        CompanyAddressState: '',
        CompanyAddressStateName: '',
        alternateMobileNumber: '',
        residentTypeID: 0,
        residentStatusCode: "RESIDENT_INDIVIDUAL",
        citizenship: 'IN',
        //Stage Three
        nameOnCard: '',
        createCardPin: '',
        confirmCardPin: '',
        billingAddress: 'H',
        additionalCard: false,
        fatherOrMotherNameIsProvided: '',
        fatherOrMotherTitle: '',
        fatherFirstName: '',
        fatherMiddleName: '',
        fatherLastName: '',
        motherFirstName: '',
        motherMiddleName: '',
        motherLastName: '',
        spouseFirstName: '',
        spouseMiddleName: '',
        spouseLastName: '',
        ckycNo: '',
        onlineStatements: true,
        emailCommunication: true,
        insurancePlanCommunication: true,
        additionalPreviliges: true,
        marketingCommunicationOverPhone: true,
        //communicationMode: '',
        relOfDirector: '',
        IdFyCaptureUrl: '',
        pcnNumber: '',
        sessionId : ''
    });
    const [errorData, setErrorData] = useState({
        //Stage One
        titleRequired: '',
        firstNameRequired: '',
        lastNameRequired: '',
        dateOfBirthRequired: '',
        panNumberRequired: '',
        haveForm60Required: false,
        emailRequired: false,
        mobileNumberRequired: '',
        homeAddressLine1Required: '',
        invalidHomeAddressLine1Pattern: '',
        homeAddressLine1Length: '',
        homeAddressLine2Required: '',
        invalidHomeAddressLine2Pattern: '',
        homeAddressLine2Length: '',
        homeAddressLine3Required: '',
        invalidHomeAddressLine3Pattern: '',
        homeAddressLine3Length: '',
        homeCityRequired: '',
        homeStateRequired: '',
        homePinRequired: '',
        employmentStatusRequired: '',
        annualIncomeRequired: '',
        disclaimerRequired: false,
        //Stage Two
        schoolRequired: '',
        schoolEmailRequired: false,
        companyNameRequired: false,
        companyEmailRequired: false,
        industryRequired: '',
        OfficeAddressLine1Required: '',
        OfficeAddressLine2Required: '',
        OfficeAddressLine3Required: '',
        CompanyAddressPincodeRequired: '',
        companyAddressStateRequired: '',
        companyAddressCityRequired: '',
        altNumberRequired: '',
        residenceTypeRequired: '',
        residenceStatusRequired: '',
        // Stage Three
        nameOnCardRequired: '',
        cardPinRequired: '',
        confirmCardPinRequired: '',
        fatherOrMotherNameRequired: '',
        fatherOrMotherTitleRequired: '',
        fatherOrMotherFNameRequired: '',
        fatherOrMotherLNameRequired: '',
        fatherOrMotherFNameAlphaNumeric: '',
        fatherOrMotherMNameAlphaNumeric: '',
        fatherOrMotherLNameAlphaNumeric: '',
        ckycAlphaNumericRequired: '',
        //communicationModeRequired: '',
        relOfDirectorRequired: ''
    });
    const [validationMessage, setValidationMessage] = useState([]);
    const [apiOutput, setAPIOutput] = useState(null);    
    const history = useHistory();
    const [showBackButton, setShowBackButton] = useState(true);
    const [intervalID, setIntervalID] = useState(0);
    const [shouldIntervalBeCancelled, setShouldIntervalBeCancelled] = useState(false);
    const [bioCatchId, setBioCatchId] = useState(null);
    const [inAuthId, setInAuthId] = useState(null);
    const pageLoad = useRef(0);

    useEffect(() => {
        window.setITag("cardformload", "success", "23642");

        //if (product.toLowerCase() === "platinumreservecreditcard" || product.toLowerCase() === "platinumreservecard") {
        //    history.push("/CantApply");
        //}

        const fetchData = async () => {
            const result = await fetch(`${API_ENDPOINTS.JOURNEYCONTENT_GET}${CONSTANTS.journey.twoStageForm}/${product}/${offerCode != 'undefined' ? offerCode: ''}`)
                .then(response => response.json())
                .then(json => json)
                .catch(err => {});

            setTwoStageFormData(result);

            if (result.isLimitExceeded) {
                setStage(CONSTANTS.stagesInTwoStage.limitExceeded);
            }
        }

        const fetchUniqueId = async () => {
            await fetch(`${API_ENDPOINTS.SESSIONID_GET}`)
                .then(response => response.text())
                .then(response => {
                    setFormData(previous => {
                        return {
                            ...previous,
                            sessionId: response
                        }
                    });
                })
                .catch(err => {});
        }

        fetchData();
        fetchUniqueId();
        if (page != undefined && page != "") {
            if (!isNaN(page)) {
                setStage(parseInt(page));
            }
            else {
                if (page == "AP1") {
                    history.push(`/TwoStageForm/${product}`)
                }
            }
            
        }

        if (location.state !== undefined) {
            const result = JSON.parse(location.state);
            setFormData({
                ...formData, pcnNumber: result.data.pcnNumber,
                employmentStatus: result.data.employmentType,
                alternateMobileNumber: result.data.officePhone,
                nameOnCard: result.data.nameOnCard,
                firstName: result.data.firstName,
                middleName: result.data.middleName,
                lastName: result.data.lastName,
                haveForm60: result.data.haveForm60,
                panNumber: result.data.panCardNumber,
                title: result.data.title
            });
            history.replace({ ...history.location.state, undefined });
            if (result.data.officePhone === undefined || result.data.officePhone === '' || result.data.officePhone === null) {
                setStage(2);
            } else if (result.data.nameOnCard === undefined || result.data.nameOnCard === '' || result.data.nameOnCard === null) {
                setShowBackButton(false);
                setStage(3);
            }
            else {
                setStage(1);
            }
        }
        else {
            setStage(1);
        }

        let myIntervalID = setInterval(loadBCIAScripts, 1000);
        setIntervalID(myIntervalID);
    }, []);

    useEffect(() => {
        if (shouldIntervalBeCancelled) {
            clearInterval(intervalID);
        }
    }, [shouldIntervalBeCancelled]);

    const incrementLoad = () => {
        pageLoad.current = pageLoad.current + 1;
    }

    const loadBCIAScripts = () => {
        if (!shouldIntervalBeCancelled) {
            let arr = [];
            arr = InitializeBiocatchInauth();
            if (arr.length > 0) {
                setShouldIntervalBeCancelled(true);
                setBioCatchId(arr[0]);
                setInAuthId(arr[1]);
            }
        }
    }
    const setResult = res => {
        if (res !== 'error')
            setStage(2);
    }
    const handleFirstStageSubmit = async (e) => {
        e.currentTarget.children[1].children[0].disabled = true;
        e.preventDefault();
        window.scrollTo(0, 0);

        for (const value of Object.values(errorData)) {
            if (value === true) { e.currentTarget.children[1].children[0].removeAttribute("disabled"); return true; }
        }
        setLoading(true);
        const searchParams = new URLSearchParams(location.search);
        if (location.search != "")
        {
            // Create the new one
            const newParams = new URLSearchParams();
            for (const [name, value] of searchParams)
            {
                newParams.append(name.toLowerCase(), value);
            }
            
            if (newParams.has("siteid")) Siteid = newParams.get("siteid");
            if (newParams.has("adunit")) AdUnit = newParams.get("adunit");
            if (newParams.has("banner")) BannerName = newParams.get("banner");
            if (newParams.has("marketingagency")) MarketingAgency = newParams.get("marketingagency");
            if (newParams.has("specialcampaign")) SpecialCampaign = newParams.get("specialcampaign");
            if (newParams.has("campaign")) Campaign = newParams.get("campaign");
            if (newParams.has("keyword")) Keyword = newParams.get("keyword");
            if (newParams.has("adgroup")) Adgroup = newParams.get("adgroup");
            if (newParams.has("cpid")) CPID = newParams.get("cpid");
            if (newParams.has("partner")) Partner = newParams.get("partner");
        }

        JioPixel(searchParams.get('cid'));
        CallIMOOnAgreeAndContinue();
        CallCriteoOnAgreeAndContinue();

        let lstForm = {
            "SessionId": formData.sessionId,
            "Salutation": formData.title,
            "FirstName": formData.firstName,
            "MiddleName": formData.middleName,
            "LastName": formData.lastName,
            "DateOfBirth": formData.dateOfBirth,
            "PAN": formData.panNumber,
            "HaveForm60": formData.haveForm60,
            "EmailId": formData.email,
            "MobileNumber": formData.mobileNumber,
            "HomeAddressLine1": formData.homeAddressLine1,
            "HomeAddressLine2": formData.homeAddressLine2,
            "HomeAddressLine3": formData.homeAddressLine3,
            "HomeAddressPincode": formData.homePin,
            "HomeAddressCity": formData.homeCity,
            "HomeAddressState": formData.homeState,
            "EmploymentStatus": formData.employmentStatus,
            "AnnualIncome": formData.annualIncome,
            "SelectedCard": data.selectedProduct,
            "OfferCode": offerCode,
            "Disclaimer": formData.disclaimer,
            "JourneyName": CONSTANTS.journey.twoStageForm,
            "SiteId": Siteid,
            "AdUnit": AdUnit,
            "Banner": BannerName,
            "MarketingAgency": MarketingAgency,
            "SpecialCampaign": SpecialCampaign,
            "Campaign": Campaign,
            "Keyword": Keyword,
            "Adgroup": Adgroup,
            "CPID": CPID,
            "Partner": Partner,
            "BioCatchId": bioCatchId,
            "InAuthId": inAuthId
        };
        let jsonData = JSON.stringify(lstForm);
        await fetch(`${API_ENDPOINTS.STAGE1_SUBMIT}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: jsonData
        }).then(async response => {
            if (response.ok) {
                const data = await response.json();
                setAPIOutput(data);
                AmazonPixelAboutYouSubmitted(data.selectedProduct);
                return data;
            }
            else {
                let messageArray = [];
                if (response.status === 400) {
                    const data = await response.json();
                    //Use to set validation on front end which we get from backend 
                    if (typeof (data.errors) === "object") {
                        Object.entries(data.errors).map(([key, val]) => {
                            messageArray.push(val); 
                        });
                    }
                }
                else if (response.status === 500) {
                    setStage(CONSTANTS.stagesInTwoStage.genericError);
                }
                else {
                    messageArray.push(errorMessage);
                }
                setValidationMessage(...messageArray);                
                setLoading(false);
                window.scrollTo(0, 0);
                throw new Error(data);
            }
        })
            .then(data => {
                window.setITag("page1submit", data.go2ApiDecision, "23643");

                setValidationMessage([]);
                setFormData({ ...formData, pcnNumber: data.go2ApiPcnNumber })
                
                if (data.isLMSDeclined === true) {
                    setStage(CONSTANTS.stagesInTwoStage.lmsDeclined);
                    window.setITag("page1submit", "declined", "23643");
                }
                else if (!(data.go2ApiStatus === 200 || data.go2ApiStatus === 422)) {
                    setStage(CONSTANTS.stagesInTwoStage.genericError);
                }
                else if (data.go2ApiStatus === 422) {
                    setStage(CONSTANTS.stagesInTwoStage.error422);
                }
                else if (data.go2ApiDecision === CONSTANTS.go2ApiDecision.declined || data.go2ApiDecision === CONSTANTS.go2ApiDecision.cancelled) {
                    setStage(CONSTANTS.stagesInTwoStage.go2Declined);
                    window.setITag("page1submit", "declined", "23643");
                }
                else {
                    setStage(2);
                }

                window.scrollTo(0, 0);

                setLoading(false);
            })
            .catch(error => {
                setStage(CONSTANTS.stagesInTwoStage.genericError);
            });
    };

    const handleSecondStageSubmit = async (e) => {
        e.currentTarget.children[1].children[0].disabled = true
        e.preventDefault();
        for (const value of Object.values(errorData)) {
            if (value === true)
            {
                e.currentTarget.children[1].children[0].disabled = false;
                return true;
            }
        }

        setLoading(true);
        AmazonPixelAdditionalInfoClicked(data.selectedProduct);

        let lstForm = {
            "SessionId": formData.sessionId,
            "Go2ApiPcnNumber": formData.pcnNumber,
            "EmploymentStatus": formData.employmentStatus,
            "CompanyName": formData.companyName,
            "CompanyAddressLine1": formData.OfficeAddressLine1,
            "CompanyAddressLine2": formData.OfficeAddressLine2,
            "CompanyAddressLine3": formData.OfficeAddressLine3,
            "CompanyAddressPincode": formData.CompanyAddressPincode,
            "CompanyAddressCity": formData.companyAddressCity,
            "CompanyAddressStateCode": formData.companyAddressState,
            "CompanyAddressStateName": formData.CompanyAddressStateName,
            "CompanyEmailAddress": formData.companyEmail,
            "Industry": formData.industry,
            "BSchoolID": formData.schoolID,
            "SchoolEmailID": formData.schoolEmail,
            "AlternatePhoneNumber": formData.alternateMobileNumber,
            "ResidentTypeID": formData.residentTypeID,
            "ResidentStatusCode": formData.residentStatusCode,
            "CountryCode": formData.citizenship,
            "BioCatchId": bioCatchId,
            "InAuthId": inAuthId
        };

        let jsonData = JSON.stringify(lstForm);

        await fetch(`${API_ENDPOINTS.STAGE2_SUBMIT}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: jsonData
        }).then(async response => {
            if (response.ok) {
                window.setITag("page2submit", "success", "23643");
                const data = await response.json();
                return data;
            }
            else {
                let messageArray = [];
                if (response.status === 400) {
                    const data = await response.json();
                    //Use to set validation on front end which we get from backend 
                    if (typeof (data.errors) === "object") {
                        Object.entries(data.errors).map(([key, val]) => {
                            messageArray.push(val);
                        });
                    }
                }
                else if (response.status === 500) {
                    setStage(CONSTANTS.stagesInTwoStage.genericError);
                }
                else {
                    messageArray.push(errorMessage);
                }
                setValidationMessage(...messageArray);
                setLoading(false);
                window.scrollTo(0, 0);
                throw new Error(data);
            }
        }).then(data => {
            if (data.go2ApiStatus === 500) {
                setStage(CONSTANTS.stagesInTwoStage.genericErrorForStage2);
            }
            setValidationMessage([]);

            setStage(3);
            window.scrollTo(0, 0);
            setLoading(false);
        })
            .catch(error => {

            });

    };

    const handleThirdStageSubmit = async (e) => {
        e.currentTarget.children[1].children[0].children[2].children[0].disabled = true;
        e.preventDefault();

        for (const value of Object.values(errorData)) {
            if (value === true) {
                e.currentTarget.children[1].children[0].children[2].children[0].disabled = false;
                return true;
            }
        }
        setLoading(true);

        let lstForm = {
            "SessionId": formData.sessionId,
            "Go2ApiPcnNumber": formData.pcnNumber,
            "NameOnCard": formData.nameOnCard,
            "CreateCardPin": formData.createCardPin,
            "ConfirmCardPin": formData.confirmCardPin,
            "BillingAddress": formData.billingAddress === 'HomeAddress' ? 'H' : 'C',
            "AdditionalCard": formData.additionalCard,
            "FatherOrMotherNameIsProvided": formData.fatherOrMotherNameIsProvided,
            "FatherOrMotherTitle": formData.fatherOrMotherTitle,
            "FatherFirstName": formData.fatherFirstName,
            "FatherMiddleName": formData.fatherMiddleName,
            "FatherLastName": formData.fatherLastName,
            "MotherFirstName": formData.motherFirstName,
            "MotherMiddleName": formData.motherMiddleName,
            "MotherLastName": formData.motherLastName,
            "SpouseFirstName": formData.spouseFirstName,
            "SpouseMiddleName": formData.spouseMiddleName,
            "SpouseLastName": formData.spouseLastName,
            "CKYCNo": formData.ckycNo,
            "ConsentForOnlineStatements": formData.onlineStatements,
            "ConsentForEmailCommunication": formData.emailCommunication,
            "ConsentForInsurancePlanCommunication": formData.insurancePlanCommunication,
            "ConsentForAdditionalPreviliges": formData.additionalPreviliges,
            "ConsentForMarketingCommunicationOverPhone": formData.marketingCommunicationOverPhone,
            //"CommunicationMode": formData.communicationMode,
            "RelativeOfDirector": formData.relOfDirector ,
            "BioCatchId": bioCatchId,
            "InAuthId": inAuthId,
        };

        let jsonData = JSON.stringify(lstForm);


        await fetch(`${API_ENDPOINTS.STAGE3_SUBMIT}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: jsonData
        }).then(async response => {

            if (response.ok) {
                const data = await response.json();
                setLoading(false);
                setAPIOutput(data);
                return data;
            }
            else {
                let messageArray = [];
                if (response.status === 400) {
                    const data = await response.json();
                    //Use to set validation on front end which we get from backend 
                    if (typeof (data.errors) === "object") {
                        Object.entries(data.errors).map(([key, val]) => {
                            messageArray.push(val);
                        });
                    }
                }
                else if (response.status === 500) {
                    setStage(CONSTANTS.stagesInTwoStage.genericError);
                }
                else {
                    messageArray.push(errorMessage);
                }
                setValidationMessage(messageArray);
                setLoading(false);
                window.scrollTo(0, 0);
                throw new Error(data);
            }
        }).then(data => {
            window.setITag("page3submit", data.go2ApiDecision, "23644");
            setValidationMessage([]);
            let messageArray = [];
            if (data.go2ApiStatus === 500) {
                setStage(CONSTANTS.stagesInTwoStage.genericErrorForStage2);
            }
            else if (data.go2ApiStatus === 422) {
                setStage(CONSTANTS.stagesInTwoStage.error422ForStage2);
            }
            else if (data.go2ApiDecision === CONSTANTS.go2ApiDecision.pended || data.go2ApiDecision===null) {
                setStage(CONSTANTS.stagesInTwoStage.go2Pended);
            }
            //Need to revisit this loop obce vkyc integration completed
            else if (data.go2ApiDecision === CONSTANTS.go2ApiDecision.approved) {
                setFormData({ ...formData, IdFyCaptureUrl: data.idFyCaptureUrl })
                setStage(CONSTANTS.stagesInTwoStage.go2Approved);
            }
            else if (data.go2ApiDecision === CONSTANTS.go2ApiDecision.declined ||
                data.go2ApiDecision === CONSTANTS.go2ApiDecision.cancelled) {
                setStage(CONSTANTS.stagesInTwoStage.go2Declined);
                window.setITag("page3submit", "declined", "23644");
            }
            window.scrollTo(0, 0);
            e.currentTarget.children[1].children[0].children[2].children[0].disabled = false;
            setLoading(false);
        }).catch(error => {

        });
    };


    const handleBackButton = async (e) => {
        e.preventDefault();
        setStage(2);
    }

    return (
        <>
            <UserProvider value={{ formData, setFormData, errorData, setErrorData }}>
                <div className="dls-gray-01-bg">
                    {loading && (
                        <Loading showModal={true} />
                    )}
                    <div>
                        <div className="row">
                            <div className="col-md-offset-1 col-md-10">
                                <div className="row margin-1-tb">
                                    <Card className="col-md-3">
                                        {data && (
                                            <>
                                                {incrementLoad()}
                                                <Banner cardImage={data.journeyContent.cardArt} bannerTitle={data.journeyContent.bannerTitle}
                                                    bannerUrl={data.journeyContent.bannerImageSrc} cardDisplayName={data.journeyContent.cardDisplayName}
                                                    eligibilityCriteria={data.journeyContent.eligibilityCriteria} displayCityNames={data.displayCityNames}
                                                />
                                                <div>
                                                    {(stage === 1 || stage === 2 || stage === 3) &&
                                                        <SideBar productHighlights={data.journeyContent.productHighlights} journeyContent={data.journeyContent} />
                                                    }
                                                </div>
                                            </>
                                        )}
                                    </Card>
                                    <Card className="col-md-9">
                                        <div>
                                            {(stage === 1 || stage === 2 || stage === 3) &&
                                                <MultiStepTracker currentStep={stage} className="col-md-12 pad-3-t">
                                                    <Step label="About You" />
                                                    <Step label="Additional Information" />
                                                    <Step label="Card Options & Submit" />
                                                </MultiStepTracker>
                                            }
                                        </div>
                                        {stage === 1 && <StageOne data={data} handleSubmit={handleFirstStageSubmit} result={setResult} validation={validationMessage.length > 0 ? validationMessage : null} />}
                                        {stage === 2 && <StageTwoForm data={data} apiOutput={apiOutput} handleSubmit={handleSecondStageSubmit} validation={validationMessage.length > 0 ? validationMessage : null} />}
                                        {stage === CONSTANTS.stagesInTwoStage.go2Declined && <GO2Declined apiOutput={apiOutput} data={data} />}
                                        {stage === 3 && <StageThree data={data} handleSubmit={handleThirdStageSubmit} handleBackButton={handleBackButton}
                                            validation={validationMessage.length > 0 ? validationMessage : null} showBackButton={showBackButton} />}
                                        {stage === CONSTANTS.stagesInTwoStage.lmsDeclined && data && <LmsDeclined cardName={data.journeyContent.productName}
                                            declinedReason={apiOutput.lmsDeclinedReason} data={data} />}
                                        {stage === CONSTANTS.stagesInTwoStage.go2Approved && <GO2Approved apiOutput={apiOutput} data={data} />}
                                        {stage === CONSTANTS.stagesInTwoStage.go2Pended && <GO2Pended apiOutput={apiOutput} data={data} />}
                                        {stage === CONSTANTS.stagesInTwoStage.genericError && <GenericError />}
                                        {stage === CONSTANTS.stagesInTwoStage.genericErrorForStage2 && <GenericErrorForStage2 apiOutput={apiOutput} />}
                                        {stage === CONSTANTS.stagesInTwoStage.error422 && <Error422 apiOutput={apiOutput} />}
                                        {stage === CONSTANTS.stagesInTwoStage.error422ForStage2 && <Error422ForStage2 apiOutput={apiOutput} />}
                                        {stage === CONSTANTS.stagesInTwoStage.limitExceeded && <LimitExceed />}
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </UserProvider>
            {(data && pageLoad.current === 1) && (
                <>
                    {incrementLoad()} 
                    <AmazonPixelBaseCode product={data?.selectedProduct} />
                    <LinkedInPixel />
                </>
            )}
            <MetaPixel />
            <IMOPixel />
            <CriteoPixel />
            <TaboolaPixel />
            <ThinkResultPixel />
        </>
    );
}

export default TwoStageForm;
